import { bet, chat, favourite, purpleDots, referral, trade } from "@/constants";
import { useEffect, useRef, useState } from "react";
import { Button } from "../ui/button";
import ChatRoom from "./ChatRoom";
import { useNavigate } from "react-router-dom";

interface BottomBarProps {
  isVisible: boolean;
  setIsVisible: (value: boolean) => void;
}

const BottomBar = ({ isVisible, setIsVisible }: BottomBarProps) => {
  const navigate = useNavigate();
  const lastScrollTopRef = useRef(0);
  const [isChatOpen, setIsChatOpen] = useState<boolean>(false);
  function handleScroll() {
    const currentScrollTop =
      document.documentElement.scrollTop || document.body.scrollTop;
    const maxScrollTop =
      document.documentElement.scrollHeight -
      document.documentElement.clientHeight;

    if (isChatOpen) {
      setIsVisible(true);
    } else if (
      currentScrollTop / maxScrollTop > 0.9 ||
      currentScrollTop >= lastScrollTopRef.current
    ) {
      setIsVisible(false); // Scrolling down
    } else {
      setIsVisible(true); // Scrolling up
    }
    lastScrollTopRef.current = currentScrollTop <= 0 ? 0 : currentScrollTop;
  }

  useEffect(() => {
    window.addEventListener("scroll", handleScroll);
    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, [isChatOpen, isVisible]);

  const tabs = [
    {
      icon: "/assets/navbar/navbar-dex.png",
      title: "Trade",
      onClick: () => {
        navigate("/shark-dex ");
      },
      iconClass: "",
    },
    {
      icon: "/assets/navbar/navbar-bet.png",
      title: "Bet",
      onClick: () => {
        navigate("/casino/lobby?tab=sidebets");
      },
      iconClass: "",
    },
    {
      icon: "/assets/navbar/navbar-referral.png",
      title: "Referral",
      onClick: () => {
        navigate("/profile?tab=referrals");
      },
      iconClass: "",
    },
    {
      icon: "/assets/navbar/navbar-favorite.png",
      title: "Favourite",
      onClick: () => {
        navigate("/");
      },
      iconClass: "",
    },
    {
      icon: "/assets/navbar/navbar-chat.png",
      title: "Chat",
      onClick: () => setIsChatOpen(!isChatOpen),
      iconClass: "mt-2",
    },
  ];

  return (
    <div
      className={`bottom-0 z-50 max-h-[106px] w-full bg-[#001854]/70 py-4 text-white backdrop-blur-lg transition-opacity duration-300 lg:hidden ${isVisible ? "fixed opacity-100" : "hidden opacity-0"}`}
    >
      <div className="inset-2 flex items-center justify-around">
        {tabs.map((tab, index) => (
          <div className="flex flex-col items-center" key={index}>
            <div key={index} className="rounded-xl p-0" onClick={tab.onClick}>
              <img
                src={tab.icon as string}
                alt={tab.title}
                className={`h-16`}
              />
            </div>
            <span className="font-ubuntu text-xs font-semibold uppercase text-[#79BFFF]/80">
              {tab.title}
            </span>
          </div>
        ))}
      </div>

      <ChatRoom
        isOpen={isChatOpen}
        handleClose={() => setIsChatOpen(!isChatOpen)}
      />
    </div>
  );
};

export default BottomBar;
